import React from "react";
import { Link } from "react-router";
function BannerMultimedia() {
  return (
    <div className="panel-horizontal-content bg-light">
      <div className="panel-horizontal">
        <p className="sr-only">Buenos Aires se escribe en plural</p>
        <video className="card-img" controls="">
          <source src="" type="video/mp4" />
          <track src="" default="" kind="captions" srcLang="es" />
          <p>
            Su navegador no soporta vídeos HTML5. Puedes ver el video haciendo
            clic en
            <a href="#">este enlace</a>.
          </p>
        </video>
        <div className="card-body">
          <h2 className="card-title">Sobre IDECABA</h2>
          <p className="card-text">
            En este video te mostramos{" "}
            <Link
              className="fw-bold text-dark text-decoration-underline"
              to="Institucional/IDECABA"
            >
              qué es
            </Link>
            , cómo funciona IDECABA y cómo podés aprovechar su información
            geográfica
          </p>
          <div className="panel-footer">
            <a
              className="btn btn-primary btn-lg"
              href="#"
              rel="noopener noreferrer"
            >
              <span className="text-white" aria-hidden="true">
                Ver más información
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BannerMultimedia;
